import {
  Action_DeleteDMGroupCategories,
  Action_DeleteDMGroupCategoriesSuccess,
  Action_DeleteDMGroupCategoriesFailed,
  Action_SaveDMGroupCategories,
  Action_SaveDMGroupCategoriesSuccess,
  Action_SaveDMGroupCategoriesFailed,
  Action_GetDMGroupCategories,
  Action_GetDMGroupCategoriesSuccess,
  Action_SaveThietLapGiaNhom,
  Action_SaveThietLapGiaNhomSuccess,
  Action_SaveThietLapGiaNhomFailed,
} from "./actionTypes";
// danh mục group Categorie
export const Index_getDMGroupCategories = (data) => ({
  type: Action_GetDMGroupCategories,
  payload: data
});
export const Index_getDMGroupCategoriesSuccess = (data) => ({
  type: Action_GetDMGroupCategoriesSuccess,
  payload: data,
});

export const Index_DeleteDMGroupCategories = (data) => ({
  type: Action_DeleteDMGroupCategories,
  payload: data
});
export const Index_DeleteDMGroupCategoriesSuccess = (data) => ({
  type: Action_DeleteDMGroupCategoriesSuccess,
  payload: data,
});
export const Index_DeleteDMGroupCategoriesFailed = (data) => ({
  type: Action_DeleteDMGroupCategoriesFailed,
  payload: data,
});

export const Index_SaveDMGroupCategories = (data) => ({
  type: Action_SaveDMGroupCategories,
  payload: data
});
export const Index_SaveDMGroupCategoriesSuccess = (data) => ({
  type: Action_SaveDMGroupCategoriesSuccess,
  payload: data,
});
export const Index_SaveDMGroupCategoriesFailed = (data) => ({
  type: Action_SaveDMGroupCategoriesFailed,
  payload: data,
});

export const Index_SaveThietLapGiaNhom = (data) => ({
  type: Action_SaveThietLapGiaNhom,
  payload: data
});
export const Index_SaveThietLapGiaNhomSuccess = (data) => ({
  type: Action_SaveThietLapGiaNhomSuccess,
  payload: data,
});
export const Index_SaveThietLapGiaNhomFailed = (data) => ({
  type: Action_SaveThietLapGiaNhomFailed,
  payload: data,
});